"use client";

import { c as _c } from "react/compiler-runtime";
import { MegaMenuPanel } from "@/components/layout/navigation/MegaMenuPanel";
import type { MegaMenuConfig } from "@/lib/navigation";
interface MegaMenuShelfProps {
  configs: readonly MegaMenuConfig[];
  activeId: string | null;
  onClose: () => void;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

/**
 * Full-width shelf under the header bar. Every panel is rendered (also on the
 * server) and only the active one is shown: rendering nothing until hover kept
 * all of the menus' links out of the HTML, so crawlers never saw them — Ahrefs
 * reported /wissen, linked only from here, as an orphan page (2026-10-15).
 * `hidden` keeps closed panels out of layout and the accessibility tree.
 */
export function MegaMenuShelf(t0) {
  const $ = _c(29);
  const {
    configs,
    activeId,
    onClose,
    onMouseEnter,
    onMouseLeave
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== activeId || $[1] !== configs || $[2] !== onClose || $[3] !== onMouseEnter || $[4] !== onMouseLeave) {
    const shelves = configs.filter(_temp);
    let t9;
    if ($[13] !== activeId) {
      t9 = config_0 => config_0.id === activeId;
      $[13] = activeId;
      $[14] = t9;
    } else {
      t9 = $[14];
    }
    const isOpen = shelves.some(t9);
    t8 = isOpen && <div className="fixed left-0 right-0 bottom-0 bg-black/40 top-[var(--header-height)]" onClick={onClose} aria-hidden="true" />;
    t1 = "absolute left-0 right-0 top-full overflow-hidden z-[51] bg-surface shadow-[0_24px_48px_color-mix(in_srgb,var(--primary)_18%,transparent)]";
    t2 = onMouseEnter;
    t3 = onMouseLeave;
    t4 = "menu";
    t5 = "mega-menu-shelf";
    t6 = !isOpen;
    let t10;
    if ($[15] !== activeId || $[16] !== onClose) {
      t10 = config_1 => <div key={config_1.id} hidden={config_1.id !== activeId}><MegaMenuPanel config={config_1} onClose={onClose} /></div>;
      $[15] = activeId;
      $[16] = onClose;
      $[17] = t10;
    } else {
      t10 = $[17];
    }
    t7 = shelves.map(t10);
    $[0] = activeId;
    $[1] = configs;
    $[2] = onClose;
    $[3] = onMouseEnter;
    $[4] = onMouseLeave;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
    t8 = $[12];
  }
  let t9;
  if ($[18] !== t1 || $[19] !== t2 || $[20] !== t3 || $[21] !== t4 || $[22] !== t5 || $[23] !== t6 || $[24] !== t7) {
    t9 = <div className={t1} onMouseEnter={t2} onMouseLeave={t3} role={t4} id={t5} hidden={t6}>{t7}</div>;
    $[18] = t1;
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t8 || $[27] !== t9) {
    t10 = <>{t8}{t9}</>;
    $[26] = t8;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
}
function _temp(config) {
  return config.layout !== "dropdown";
}